export default __webpack_public_path__ + "static/Perroquet-fond-V-42d96698bbb41caad2fc8a1d8f972884.jpg";